import { kaspreadsheetUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden pt-16">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20artistic%20abstract%20composition%20with%20flowing%20organic%20shapes%20in%20warm%20terracotta%20sand%20and%20oatmeal%20tones%2C%20gentle%20gradient%20blending%2C%20minimalist%20textured%20design%2C%20airy%20lightweight%20feel%2C%20no%20text%2C%20clean%20modern%20aesthetic%20with%20subtle%20geometric%20undertones%2C%20Scandinavian%20inspired%20warm%20neutral%20palette&width=1600&height=1000&seq=hero-bg-v2-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/20 to-background-50/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20 pb-10">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-background-300/60 bg-background-50/60 backdrop-blur-sm mb-8">
          <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
          <span className="text-xs font-medium text-foreground-600 tracking-wide whitespace-nowrap">
            14 Product Categories Available
          </span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold font-heading text-foreground-950 leading-[1.08] tracking-tight">
          Smart Sourcing
          <br />
          Starts with{' '}
          <span className="text-primary-500">GTBuy</span>
          <br />
          Spreadsheet
        </h1>

        <p className="mt-6 text-base md:text-lg text-foreground-500 max-w-xl mx-auto leading-relaxed">
          The all-in-one sourcing and order management tool built for resellers who demand speed, accuracy, and simplicity in their daily workflow.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <a
            href={kaspreadsheetUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold text-white bg-foreground-900 hover:bg-foreground-800 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Explore GTBuy Sheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
          <a
            href={kaspreadsheetUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold text-foreground-700 bg-white hover:bg-background-100 border border-background-200 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            buy it now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>

      {/* Floating Product Cards */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 pb-16 md:pb-24">
        <div className="flex items-end justify-center gap-4 md:gap-6">
          <div className="hidden md:block w-[260px] lg:w-[320px] bg-white rounded-2xl border border-background-200/70 overflow-hidden transform -rotate-3 translate-y-8 hover:rotate-0 hover:translate-y-0 transition-all duration-500">
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20a%20pair%20of%20vintage%20style%20tennis%20sneakers%20in%20cream%20and%20green%2C%20placed%20on%20a%20light%20terracotta%20tile%20surface%2C%20soft%20morning%20light%20from%20upper%20left%2C%20warm%20neutral%20tones%2C%20airy%20editorial%20style%20with%20clean%20shadows&width=600&height=800&seq=hero-card-left-v2&orientation=portrait"
                alt="Sneakers collection"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <p className="text-xs font-medium text-foreground-400 uppercase tracking-wider">Shoes</p>
              <p className="text-sm font-semibold text-foreground-900 mt-0.5 whitespace-nowrap">Vintage Tennis Collection</p>
            </div>
          </div>

          <div className="w-[260px] md:w-[280px] lg:w-[340px] bg-white rounded-2xl border border-background-200/70 overflow-hidden transform -translate-y-4 hover:-translate-y-6 transition-all duration-500 z-10">
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20fashion%20photography%20of%20a%20warm%20sand%20colored%20oversized%20knit%20sweater%20draped%20over%20a%20natural%20wooden%20hanger%2C%20set%20against%20a%20light%20oyster%20wall%2C%20soft%20diffused%20window%20light%2C%20visible%20textured%20knit%20details%2C%20clean%20Scandinavian%20aesthetic%2C%20warm%20cozy%20atmosphere&width=680&height=907&seq=hero-card-center-v2&orientation=portrait"
                alt="Featured knit sweater"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <p className="text-xs font-medium text-foreground-400 uppercase tracking-wider">Knitwear</p>
              <p className="text-sm font-semibold text-foreground-900 mt-0.5 whitespace-nowrap">Premium Sweater Collection</p>
            </div>
          </div>

          <div className="hidden md:block w-[260px] lg:w-[320px] bg-white rounded-2xl border border-background-200/70 overflow-hidden transform rotate-3 translate-y-8 hover:rotate-0 hover:translate-y-0 transition-all duration-500">
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20sage%20green%20suede%20crossbody%20bag%20resting%20on%20a%20light%20travertine%20stone%20surface%2C%20soft%20natural%20daylight%2C%20minimalist%20style%20with%20visible%20texture%20details%2C%20warm%20neutral%20background%2C%20elegant%20editorial%20composition&width=600&height=800&seq=hero-card-right-v2&orientation=portrait"
                alt="Crossbody bag"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <p className="text-xs font-medium text-foreground-400 uppercase tracking-wider">Bags</p>
              <p className="text-sm font-semibold text-foreground-900 mt-0.5 whitespace-nowrap">Suede Crossbody Collection</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}